import React, { useEffect, useState } from 'react'
import { Card } from '../../../components/Card'
import { CloseBtn } from '../../../components/CloseBtn'
import FormattedMessage from '../../../helpers/FormattedMessage'
import { ModalProvider } from '../../../helpers/ModalContext'
import { useModal } from '../../../components/Modal'
import { schoolCloth } from '../../../setups/setups'
import styles from './Step2.module.scss'
import { TopSection } from '../../../components/TopSection'
import { Button } from '../../../components/Button'
import ClothingType  from '../../../assets/images/selectClothingType.png'
import { InputButton } from 'src/components/InputButton'
import { typeStaticContent } from '../../../components/ModalStatic/typeStaticContent'

interface IProps {
  nextStep: () => void
  cancel: () => void
}



export const Step2 = ({ nextStep, cancel }: IProps) => {
  const { Modal, openModal, closeModal } = useModal()
  const [clothType, setClothType] = useState(window.localStorage.getItem('School-clothType') || '')
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    window.localStorage.setItem('School-step', '2')
  }, [])

  const setClothTypeInModal = (type: string) => {
    setIsError(false)
    setClothType(type)
    closeModal()
  }

  const next = () => {
    if (clothType) {
      window.localStorage.setItem('School-clothType', clothType)
      nextStep()
    } else {
      setIsError(true)
    }
  }

  return (
    <ModalProvider>
      <TopSection
        title="SchoolShop.topSection.create.title"
        description="SchoolShop.topSection.create.description"
        hideMobile
      />
      <div className={styles.Wrapper}>
        <CloseBtn cancel={cancel} />
        <Card
          title={'SchoolShop.stage2.title'}
          description={'SchoolShop.stage2.description'}
          discoverMore={typeStaticContent}
          discoverMoreTitle="SchoolShop.stage2.modal.discoverMore.title"
        >

          <img className={styles.ContentImg} src={ClothingType} alt="clothing type"/>
          <InputButton
            label="SchoolShop.stage2.title"
            onClick={openModal}
            isError={isError}
            errorLabel="SchoolShop.stage2.error"
          >
            {clothType ? <FormattedMessage id={`ClothType.${clothType}`} /> : 'Hoodie, t-shirt, etc.'}
          </InputButton>
        </Card>
      </div>


        <Button
          center
          onClick={next}
          buttonColor
          buttonDescription="SchoolShop.stage2.button"
        />


      <Modal title="SchoolShop.stage2.modal.title">
        <div className={styles.Options}>
          {Object.keys(schoolCloth).map((item) => (
            <div className={`${styles.OptionWrapper} ${clothType === item && styles.Active}`} key={item} onClick={() => { setClothTypeInModal(item) }}>
              <img src={schoolCloth[item].img} alt={item} />
              <div>
                <FormattedMessage id={`ClothType.${item}`} />
              </div>
            </div>
          ))}
        </div>
      </Modal>
    </ModalProvider>
  )
}
